export enum IconName {
  AccountCircle = 'account_circle',
  Add = 'add',
  AddCard = 'add_card',
  AirportShuttle = 'airport_shuttle',
  ArrowBack = 'arrow_back',
  ArrowDownward = 'arrow_downward',
  ArrowForward = 'arrow_forward',
  ArrowUpward = 'arrow_upward',
  Article = 'article',
  Asterisk = 'asterisk',
  AttachFile = 'attach_file',
  AttachMoney = 'attach_money',
  AutoAwesome = 'auto_awesome',
  Bathtub = 'bathtub',
  Bed = 'bed',
  Bedtime = 'bedtime',
  Bookmark = 'bookmark',
  Build = 'build',
  CalendarToday = 'calendar_today',
  Call = 'call',
  Cancel = 'cancel',
  ChatBubbleOutline = 'chat_bubble_outline',
  Check = 'check',
  CheckCircle = 'check_circle',
  Circle = 'circle',
  Close = 'close',
  CloseSmall = 'close_small',
  Coffee = 'coffee',
  ConfirmationNumber = 'confirmation_number',
  ContentCopy = 'content_copy',
  CreditCard = 'credit_card',
  Delete = 'delete',
  Description = 'description',
  Directions = 'directions',
  DirectionsBus = 'directions_bus',
  DirectionsCar = 'directions_car',
  Download = 'download',
  DryCleaning = 'dry_cleaning',
  Edit = 'edit',
  EditSquare = 'edit_square',
  Editors = 'stylus_fountain_pen',
  ElectricBike = 'electric_bike',
  ErrorOutline = 'error_outline',
  Euro = 'euro',
  Event = 'event',
  Explore = 'explore',
  Favorite = 'favorite',
  FilterAltOff = 'filter_alt_off',
  FilterList = 'filter_list',
  Fireplace = 'fireplace',
  Flare = 'flare',
  Flight = 'flight',
  FlightLand = 'flight_land',
  FlightTakeoff = 'flight_takeoff',
  Footprint = 'footprint',
  GridView = 'grid_view',
  Groups = 'groups',
  Home = 'home',
  Image = 'image',
  Info = 'info',
  IosShare = 'ios_share',
  Key = 'key',
  KeyboardArrowDown = 'keyboard_arrow_down',
  KeyboardArrowLeft = 'keyboard_arrow_left',
  KeyboardArrowRight = 'keyboard_arrow_right',
  KeyboardArrowUp = 'keyboard_arrow_up',
  Liquor = 'liquor',
  List = 'list',
  LocalBar = 'local_bar',
  LocationOn = 'location_on',
  Luggage = 'luggage',
  MapSearch = 'map_search',
  Menu = 'menu',
  MoreHoriz = 'more_horiz',
  MoreVert = 'more_vert',
  Nature = 'nature',
  Pages = 'pages',
  PedalBike = 'pedal_bike',
  Person = 'person',
  Place = 'place',
  Redeem = 'redeem',
  Refresh = 'refresh',
  Remove = 'remove',
  Restaurant = 'restaurant',
  Route = 'route',
  Sailing = 'sailing',
  Schedule = 'schedule',
  ScubaDiving = 'scuba_diving',
  Search = 'search',
  SelfImprovement = 'self_improvement',
  SentimentSatisfied = 'sentiment_satisfied',
  Settings = 'settings',
  ShoppingCart = 'shopping_cart',
  Sort = 'sort',
  Spa = 'spa',
  StarOutline = 'star_outline',
  Storefront = 'storefront',
  SwapVert = 'swap_vert',
  TableRestaurant = 'table_restaurant',
  TheaterComedy = 'theater_comedy',
  Train = 'train',
  TravelExplore = 'travel_explore',
  UnfoldLess = 'unfold_less',
  UnfoldMore = 'unfold_more',
  Verified = 'verified',
  Visibility = 'visibility',
  VisibilityOff = 'visibility_off',
  Wifi = 'wifi',
  Work = 'work',
}
